module.exports = __webpack_public_path__ + "static/cabina-de-conductor---mampara-divisoria-0d599e8941a2e37c7a70d6d7f0cc9c34.jpg";